/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon16Solid = forwardRef('ArrowCollapseCHOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.073 9.591a2.25 2.25 0 0 1 0-3.182l2.793-2.793a1.25 1.25 0 1 1 1.768 1.768L4.018 8l2.616 2.616a1.25 1.25 0 1 1-1.768 1.768L2.073 9.591Z" }),
        React.createElement("path", { d: "M13.927 9.591a2.25 2.25 0 0 0 0-3.182l-2.793-2.793a1.25 1.25 0 0 0-1.768 1.768L11.982 8l-2.616 2.616a1.25 1.25 0 1 0 1.768 1.768l2.793-2.793Z" })));
});
